import _get from 'lodash/get';
import _chunk from 'lodash/chunk';
import ctf from 'utils/contentfulService';

const maxItemsPerRequest = 100;

const getResourcesQueryFn = async (_key, { localeFilters, sysIds }) => {
  const batches = _chunk(sysIds, maxItemsPerRequest);

  const responses = await Promise.all(
    batches.map(batch =>
      ctf.getEntries({
        'sys.id[in]': batch.join(','),
        include: 2,
        ...localeFilters,
      }),
    ),
  );

  return responses.flatMap(response => _get(response, 'items', []));
};

export default getResourcesQueryFn;
